<template lang="html">
  <section>
    <li class="m-item" :id="tid" v-if="tVisible" v-on:click="onSelected(tid)">
      <div class="hardcoded-value">
        <mark>{{ STRING_TRUE }}</mark>
      </div>
    </li>

    <li class="m-item" :id="fid" v-if="fVisible" v-on:click="onSelected(fid)">
      <div class="hardcoded-value">
        <mark>{{ STRING_FALSE }}</mark>
      </div>
    </li>
  </section>
</template>

<script lang="js">
  import { v4 as uuidv4 } from "uuid";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import store from "@/store";

  export default  {
    name: "hardcoded-boolean",
    props: {
      tid: {
        type: String,
        default: "static-boolean-true" + uuidv4()
      },
      fid: {
        type: String,
        default: "static-boolean-false" + uuidv4()
      },
      exp: {
        type: String
      }
    },
    computed: {
      tVisible() {
        return this.regEx? this.regEx.test(this.STRING_TRUE) : false;
      },
      fVisible() {
        return this.regEx? this.regEx.test(this.STRING_FALSE) : false;
      },
      regEx() {
        return this.exp? new RegExp(this.exp, "gi") : null;
      }
    },
    data () {
      return {
        STRING_TRUE: this.getMessageText(store.getters.messages.BOOLEAN_TRUE),
        STRING_FALSE: this.getMessageText(store.getters.messages.BOOLEAN_FALSE),
      }
    },
    methods: {
      onSelected(id) {
        let value;
        if(this.$listeners && this.$listeners["on-search-box-item-selected"]) {
          value = !!id.includes("true");
          let label = value ? this.STRING_TRUE : this.STRING_FALSE;
          this.$emit("on-search-box-item-selected", this.getExpression(value, label));
        }
      },
      getExpression(value, label) {
        return expressionBuilder.getStaticBooleanExpression({value, label});
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../styles/components/elements";

  .hardcoded-value {
    overflow: hidden;
    padding: 0.75rem;
  }

  .m-item:hover {
    background-color: $list-item-hover-color;
    text-decoration: none;
    cursor: pointer;
  }
</style>
